import React, { useRef, useState, useEffect } from "react";
import { motion, useScroll, useTransform, AnimatePresence } from "framer-motion";
import heroBg from "../Imagenes/MainBG.png";

// Extraemos la lógica del texto a un componente independiente
const RotatingText = () => {
  const words = ["soluciones digitales", "sistemas", "software a medida", "páginas web"]; // Arreglo con los textos
  const [index, setIndex] = useState(0); // Estado que solo afectará a este componente

  useEffect(() => {
    // El efecto ahora vive solo aquí adentro
    const interval = setInterval(() => {
      // Iniciamos el intervalo
      setIndex(prev => (prev + 1) % words.length); // Actualizamos la palabra
    }, 2500); // Cada 2.5 segundos
    return () => clearInterval(interval); // Limpiamos al desmontar
  }, []); // Dependencias vacías

  return <div className="relative max-[360px]:h-[2em] h-[1.1em] overflow-visible">
      <AnimatePresence mode="wait">
        <motion.h2 key={index} // Obliga a React a animar el cambio
      initial={{
        y: 20,
        opacity: 0
      }} // Estado inicial
      animate={{
        y: 0,
        opacity: 1
      }} // Estado visible
      exit={{
        y: -20,
        opacity: 0
      }} // Estado de salida
      transition={{
        duration: 0.4,
        ease: "easeInOut"
      }} // Duración y curva
      className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-[0.95] tracking-tight pb-1 absolute" // Clases de Tailwind
      >
          {words[index]}
        </motion.h2>
      </AnimatePresence>
    </div>;
};
const Main = () => {
  const containerRef = useRef(null);
  const scrollToSection = sectionId => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  return <div ref={containerRef} id="inicio" className="relative w-full min-h-screen flex overflow-hidden bg-[#000000]">

      <motion.div className="absolute inset-0 z-0" initial={{
      opacity: 0,
      scale: 1.05
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.5,
      delay: 0.8,
      ease: "easeOut"
    }} style={{
      backgroundImage: `url(${heroBg})`,
      backgroundSize: "cover",
      backgroundPosition: window.innerWidth < 768 ? "" : "center"
    }} />

      {/* Contenido principal */}
      <motion.div className="relative z-10 flex flex-col justify-center w-full min-h-screen px-6 md:px-12 lg:px-20">
        <div className="max-w-6xl w-full">


          {/* Título principal - alineado a la izquierda, letras más pequeñas */}
          <div className="sm:mt-8">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            ease: "easeOut",
            delay: 0.4
          }} className="overflow-hidden">
              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-white leading-[0.95] tracking-tight">
                En{" "}
                <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#bdff57] to-[#9adb35]">
                  VITRUM
                </span>
              </h1>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            ease: "easeOut",
            delay: 0.6
          }} className="overflow-hidden">
              <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-white leading-[0.95] tracking-tight mt-4">
                desarrollamos
              </h2>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            ease: "easeOut",
            delay: 0.8
          }} className="py-3 flex flex-col">

              <RotatingText />

              <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-[0.95] tracking-tight mt-8 lg:mt-16">
                para tu organización
              </h2>

            </motion.div>
          </div>

          {/* Descripción - alineada a la izquierda */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          ease: "easeOut",
          delay: 1
        }} className="mt-8 text-base md:text-lg text-gray-400 max-w-xl leading-relaxed">
            Transformamos ideas en productos digitales que impulsan el crecimiento de tu negocio con tecnología de vanguardia.
          </motion.p>

          {/* CTAs - alineados a la izquierda */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          ease: "easeOut",
          delay: 1.2
        }} className="mt-10 flex flex-col sm:flex-row flex-wrap gap-4">
            <button className="group relative px-8 py-4 bg-[#bdff57] text-black font-semibold rounded-xl overflow-hidden transition-all duration-300 hover:scale-105" onClick={() => scrollToSection("contacto")}>
              <span className="relative z-10 flex items-center justify-center gap-2">
                Contáctanos
                <svg className="w-5 h-5 group-hover:translate-y-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-[#bdff57] to-[#9adb35] opacity-0 group-hover:opacity-100 transition-opacity" />
            </button>

            <button className="group flex items-center justify-center gap-3 px-8 py-4 bg-white/5 backdrop-blur-sm text-white font-semibold rounded-xl border border-white/10 hover:bg-white/10 hover:border-[#bdff57]/30 transition-all duration-300" onClick={() => scrollToSection("servicios")}>
              Ver servicios
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </motion.div>

        </div>
      </motion.div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 2
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-20">
        <div className="w-6 h-10 rounded-full border-2 border-white/20 flex justify-center pt-2">
          <motion.div animate={{
          y: [0, 12, 0]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="w-1.5 h-1.5 bg-[#bdff57] rounded-full" />
        </div>
      </motion.div>
    </div>;
};
export default Main;